const names = [
    'undo',
    'redo',
    'bold',
    'italic',
    'underline',
    'strike',
    'mono',
    'mark',
    'paragraph',
    'heading1',
    'heading2',
    'heading3',
    'heading4',
    'heading5',
    'heading6',
    'bulletList',
    'orderedList',
    'liftListItem',
    'sinkListItem',
    'checkbox',
    'link',
    'quote',
    'yfm_cut',
    'yfm_note',
    'yfm_block',
    'yfm_layout',
    'table',
    'code_inline',
    'code_block',
    'image',
    'horizontalrule',
    'emoji',
    'file',
    'anchor',
    'math_inline',
    'math_block',
    'tabs',
    'mermaid',
];
const namesObj = names.reduce((obj, val) => {
    obj[val] = val;
    return obj;
}, {});
export const ActionName = namesObj;
